<template lang="pug">
  div.body.body-table
    div.table-choose-panel
      div.toolbar-table
        div.e-select-list.select.list
        div.toolbar.toolbar--modal
          div.line
            div.actions-panel
              e-button-add(@click="addNewRowToTable")
      div
        e-table-editable(
          ref="detail"
          :attributes="detailAttr"
          :dataUrl="dataUrl"
          :postUrl="postUrl"
          :patchUrl="patchUrl"
          :deleteUrl="deleteUrl"
          :tableInOnlineMode="tableInOnlineMode"
          @sortByField="onSortByField"
          @paginate="onPaginate"
          :tableHeight="'400'"
          :tableHeightRight="'400'"
          :fewRowsCount="2"
          :afterFetchData="afterFetchData"
        )
</template>

<script>
import { CALENDAR } from '@/config/config'
import { transport } from '@/api/api-endpoints'

export default {
  name: 'transport-maintenance-table',
  props: {
    id: null,
    inputModel: Object,
  },
  data() {
    return {
      search: '',
      searchModel: '',
      sort: null,
    }
  },
  computed: {
    tableInOnlineMode() {
      return this.$route.params.id
    },
    enableSort() {
      return true
    },
    detailAttr() {
      return {
        maintenance_type: {
          label: 'Тип',
          validationRulePattern: '(\\.*)',
          required: true,
          select: {
            options: this.maintenanceTypes,
          },
          transform: (model) => model.labelFormaintenance_type,
        },
        name: {
          label: 'Наименование',
          placeholder: ' ',
          validationRulePattern: '(\\.*)',
        },
        dt_start: {
          label: 'Дата начала',
          placeholder: ' ',
          validationRulePattern: '(\\.*)',
          calendar: {
            valueFormat: CALENDAR.format,
            format: CALENDAR.format,
          },
        },
        td_end: {
          label: 'Дата окончания',
          placeholder: ' ',
          validationRulePattern: '(\\.*)',
          calendar: {
            valueFormat: CALENDAR.format,
            format: CALENDAR.format,
          },
        },
        velocity: {
          label: 'Пробег',
          placeholder: ' ',
          validationRulePattern: '^(\\d*)$',
        },
        condition: {
          label: 'Состояние ТС',
          validationRulePattern: '(\\.*)',
          select: {
            options: this.conditions,
          },
          transform: (model) => model.labelForcondition,
        },
        composition: {
          label: 'Состав работ',
          placeholder: ' ',
          validationRulePattern: '(\\.*)',
        },
        comment: {
          label: 'Комментарии',
          placeholder: ' ',
          validationRulePattern: '(\\.*)',
        },
      }
    },
    parentId() {
      return this.inputModel.id || this.inputModel._storeUUID
    },
    dataUrl() {
      let routeQuery = {
        query: {
          tko_transport_id: this.inputModel.id,
        },
      }
      if (this.search) {
        routeQuery.query.q = this.search
      }
      if (this.sort) {
        routeQuery.query.sort = this.sort
      }
      routeQuery.query['per-page'] = -1

      return transport.maintenanceOrders(routeQuery)
    },
    maintenanceTypes() {
      return [
        { id: 1, name: 'ТО' },
        { id: 2, name: 'Ремонт' },
      ]
    },
    conditions() {
      return [
        { id: 1, name: 'Исправен' },
        { id: 2, name: 'Потребуется ремонт' },
        { id: 3, name: 'Отправлен на ремонт' },
      ]
    },
  },
  methods: {
    postUrl() {
      return transport.maintenance()
    },
    patchUrl(context, model) {
      return transport.maintenance(model.id)
    },
    deleteUrl(context, model) {
      return transport.maintenance(model.id)
    },
    onPaginate(paginationQuery) {
      this.paginationQuery = paginationQuery
    },
    onSortByField({ sort }) {
      this.sort = sort
    },
    afterFetchData(ctx, data) {
      if (!this.tableInOnlineMode) {
        data.data = data.data.filter((v) => v.parentId === this.parentId)
      }
      return data
    },
    // tmp method
    getTableData() {
      return this.$refs.detail.data
    },
    addNewRowToTable() {
      const Model = (id, parentId) => {
        return {
          maintenance_type: '',
          condition: '',
          sourceId: id || '',
          parentId: parentId || '',
        }
      }
      this.$refs.detail.createRow(new Model(this.id, this.parentId))
    },
  },
}
</script>
